import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

export const LoadingSkeletonPost = styled(Skeleton)(({ theme }) => ({
  marginTop: '1rem',
  minWidth: '17rem',
  height: '21rem',
  borderRadius: '1rem',

  [theme.breakpoints.down('md')]: {
    minWidth: '100%',
  },
}));

export const CarouselContainer = styled(Box)(({ theme }) => ({
  height: '28rem',
  borderRadius: '0.8rem',
  boxShadow: theme.customShadows.z24,
  margin: '0 auto',
  textAlign: 'center',
  position: 'relative',
  marginBottom: '2.5rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.between('sm', 'lg')]: {
    maxWidth: '90vw',
    margin: '0 auto',
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '90vw',
    margin: '0 auto',
  },
}));

export const CarouselTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: theme.palette.grey[500],
  margin: '1.68rem 0 1.9rem',
}));

export const Carrousel = styled(Box)(({ theme }) => ({
  overflow: 'auto',
  width: '100%',
  display: 'flex',
  gap: '1.1rem',
  justifyContent: 'space-between',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const ArrowLeft = styled('img')(({ theme }) => ({
  width: '1.8rem',
  height: '1.8rem',
  borderRadius: '50%',
  position: 'absolute',
  left: '1rem',
  top: 'calc(50% - 0.9rem)',
  rotate: '180deg',
}));

export const ArrowRight = styled('img')(({ theme }) => ({
  width: '1.8rem',
  height: '1.8rem',
  borderRadius: '50%',
  position: 'absolute',
  right: '1rem',
  top: 'calc(50% - 0.9rem)',
}));
